.content {
  padding: 6px;
  /* panel radius = control radius + panel padding / 2 */
  border-radius: calc(6px + 6px / 2);
  min-width: 216px;
}

.separator {
  height: 1px;
  background-color: var(--color-highlightMed);
  margin: 6px 0;
}

.item {
  display: block;
  padding: 6px 12px;
  border-radius: 6px;
  color: var(--color-text);

  /* for button */
  appearance: none;
  border: none;
  background: transparent;
  width: 100%;
  text-align: left;

  /* for link */
  text-decoration: none;
  cursor: default;
}

.item[data-highlighted] {
  background-color: var(--color-overlay);
}
